"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/BlockListTab/AddBlockModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _phone = require('shared/services/phone');

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');







const AddBlockModal = ({ isOpen, onClose, onProceed }) => {
  const [phoneNumber, setPhoneNumber] = _react.useState.call(void 0, '')
  const [isSubmitting, setIsSubmitting] = _react.useState.call(void 0, false)
  const parsedPhoneNumber = _react.useMemo.call(void 0, 
    () => _phone.parsePhoneInputValue.call(void 0, phoneNumber),
    [phoneNumber],
  )
  const isValidPhoneNumber =
    _phone.isCompletePhoneInput.call(void 0, parsedPhoneNumber.callingCode, parsedPhoneNumber.nationalDigits)

  _react.useEffect.call(void 0, () => {
    if (!isOpen) setPhoneNumber('')
  }, [isOpen])

  const submit = _react.useCallback.call(void 0, 
    () => {
      setIsSubmitting(true)
      onProceed(phoneNumber)
        .then(() => {
          setPhoneNumber('')
          onClose()
        })
        .catch(() => undefined)
        .finally(() => setIsSubmitting(false))
    },
    [onProceed, phoneNumber, onClose],
  )

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: isOpen,
      onClose: onClose,
      title: "Block phone number"  ,
      className: "team-page--block-list--add-modal", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}

      , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}, "They won't be able to text any of your organization's lines, and we won't text them."

      )
      , _react2.default.createElement(_Form.InputSectionWrapper, {
        title: "Phone Number" ,
        className: "team-page--block-list--add-modal--phone-section",
        shouldCaptureFocus: false, __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}

        , _react2.default.createElement(_Form.PhoneInput, {
          autoFocus: true,
          value: phoneNumber,
          isDisabled: isSubmitting,
          onChange: setPhoneNumber, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
        )
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: "Block",
        secondaryBtnLabel: "Cancel",
        isPrimaryEnabled: isValidPhoneNumber && !isSubmitting,
        isPrimaryLoading: isSubmitting,
        onPrimaryBtnClick: submit,
        onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
      )
    )
  )
}

exports. default = AddBlockModal
